'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _data = require('./data.js');

var _data2 = _interopRequireDefault(_data);

var _alpha2 = require('./alpha2.js');

var _alpha3 = _interopRequireDefault(_alpha2);

var _index = require('./translation/index.js');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Countries = function () {
    function Countries() {
        _classCallCheck(this, Countries);

        this.data = _lodash2.default.cloneDeep(_data2.default);
    }

    _createClass(Countries, [{
        key: 'init',
        value: function init() {
            this.data = _lodash2.default.cloneDeep(_data2.default);
            return this;
        }
    }, {
        key: 'values',
        value: function values() {
            return this.data;
        }
    }, {
        key: 'toArray',
        value: function toArray() {
            return _lodash2.default.map(this.data, function (value, key) {
                return { code: key, name: value };
            });
        }
    }, {
        key: 'translate',
        value: function translate(lang) {
            lang = lang.toUpperCase();
            var transl = _index2.default[lang.length == 2 ? lang : _alpha3.default[lang]] || null;
            if (!transl) return this;
            this.data = _lodash2.default.mapValues(this.data, function (value, key) {
                return key.length === 3 ? transl[_alpha3.default[key]] || value : transl[key] || value;
            });
            return this;
        }
    }, {
        key: '_arrayToObject',
        value: function _arrayToObject(arr) {
            return _lodash2.default.cloneDeep(_lodash2.default.mapValues(_lodash2.default.mapKeys(arr, function (value) {
                return value[0];
            }), function (value) {
                return value[1];
            }));
        }
    }, {
        key: '_to2Array',
        value: function _to2Array() {
            return _lodash2.default.map(this.data, function (value, key) {
                return [key, value];
            });
        }
    }, {
        key: '_sort',
        value: function _sort(i) {
            var arr = this._to2Array();
            return this._arrayToObject(arr.sort(function (a, b) {
                return a[i].toLowerCase().localeCompare(b[i].toLowerCase());
            }));
        }
    }, {
        key: 'sortByKey',
        value: function sortByKey() {
            this.data = this._sort(0);
            return this;
        }
    }, {
        key: 'sortByName',
        value: function sortByName() {
            this.data = this._sort(1);
            return this;
        }
    }, {
        key: 'alpha2',
        value: function alpha2() {
            this.data = _lodash2.default.mapKeys(this.data, function (value, key) {
                return _alpha3.default[key] || key;
            });
            return this;
        }
    }, {
        key: 'favorites',
        value: function favorites(countries) {
            countries = _lodash2.default.isArray(countries) ? countries : [countries];
            var arr = this._to2Array();
            _lodash2.default.forEachRight(countries, function (c) {
                c = c.length === 2 ? c.toUpperCase() : _alpha3.default[c.toUpperCase()];
                var i = _lodash2.default.findIndex(arr, function (item) {
                    var key = item[0].length === 2 ? item[0] : _alpha3.default[item[0]];
                    return c === key;
                });
                if (i >= 0) {
                    arr.unshift(arr[i]);
                    arr.slice(i, 1);
                }
            });
            this.data = this._arrayToObject(arr);
            return this;
        }
    }]);

    return Countries;
}();

exports.default = new Countries();


//////////////////
// WEBPACK FOOTER
// ./~/countries-3166/lib/index.js
// module id = 909
// module chunks = 1